import jQuery from "jquery";

window.$ = window.jQuery = jQuery;

// Script responses to remote links (jquery_ujs, e.g. groups/subscribe.js.erb) run
// as an inline script; the page nonce lets them pass the nonce-based script policy.
jQuery.ajaxSetup({
  converters: {
    "text script"(text) {
      const nonce = document.querySelector('meta[name="csp-nonce"]')?.content;
      jQuery.globalEval(text, { nonce });
      return text;
    },
  },
});

export default jQuery;
